export const convertModel = <T, M>(obj: T | null | undefined, model: (json: T) => M) => {
	if (!obj) return null
	return model(obj)
}

export const convertArrayModel = <T, M>(obj: T[] | null | undefined, model: (json: T) => M) => {
	if (!obj) return []
	return obj.map(model)
}

export const convertLangContent = <K extends string, T extends Record<K, ILangContent[] | null>>(
	json: T,
	...rest: K[]
) => {
	const convertedValues = {} as Record<string, ReturnType<typeof LangContentToModel>>

	rest.forEach(key => {
		const value = json[key]
		if (!value) return
		convertedValues[keyToCamelCase(String(key))] = LangContentToModel(value)
	})

	return convertedValues
}

export const convertModelDate = (date: string | null) => {
	if (!date) return null
	return new Date(date)
}

export const convertModelDates = <K extends string, T extends Record<K, string>>(json: T, ...rest: K[]) => {
	const convertedValues = {} as Record<string, Date>
	rest.forEach(key => {
		convertedValues[keyToCamelCase(String(key))] = new Date(json[key])
	})

	return convertedValues
}
